<app-page-body>
  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section>
        <fieldset>
          <legend>
            {{ "common.pricePerPart" | translate }}
          </legend>

          <div class="row">
            <!-- title -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-[275px]"
                enumName="SmsCp"
                [label]="'common.aggregator'"
                [control]="form?.get('smsCp')"
                [(value)]="model.SmsCp"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- postalCode -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
              <enum-select-search
                class="tw-w-[275px]"
                enumName="PhoneNumberRegions"
                [label]="'common.region'"
                [control]="form?.get('region')"
                [(value)]="model.Region"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>
          </div>
          <div
            class="fw-bold tw-rounded-[10px] tw-flex tw-items-center rounded bg-light-primary tw-p-5 sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
          >
            {{ pricePerPart | numberSeparator }}
          </div>
          <!-- form btns-->
          <app-form-btns
            [loading]="loading"
            [form]="form"
            [isEdit]="formPageConfig.isEditMode"
            [customTitle]="'common.calculate'"
            [showCloseBtn]="false"
            (onSubmit)="onSubmit()"
          >
          </app-form-btns>
        </fieldset>
      </section>
    </form>
  </div>
</app-page-body>
